/**
 * EN | UA toggle for the editorial Nav.
 *
 * Click sets the language via `useLang().setLang(code)`. No reload: every
 * data loader is keyed by language and every hook that reads one lists `lang`
 * in its deps, so the page re-renders in place.
 */
import React from 'react';
import { useLang } from '../../i18n/LangContext';
import { Lang, SUPPORTED_LANGS } from '../../i18n/detectLanguage';
import { useT } from '../../i18n/useT';
import { mono, ivory, muted } from './EditorialShell';

const LangSwitcher: React.FC = () => {
    const { lang, setLang } = useLang();
    const t = useT();

    return (
        <div
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                fontFamily: mono,
                fontSize: 12,
                letterSpacing: '0.06em',
            }}
        >
            {SUPPORTED_LANGS.map((code, i) => {
                const isActive = code === lang;

                return (
                    <React.Fragment key={code}>
                        {i > 0 && <span style={{ color: 'rgba(255,255,255,0.18)' }}>|</span>}
                        <button
                            type="button"
                            onClick={() => setLang(code as Lang)}
                            disabled={isActive}
                            style={{
                                background: 'transparent',
                                border: 'none',
                                padding: '4px 2px',
                                fontFamily: 'inherit',
                                fontSize: 'inherit',
                                letterSpacing: 'inherit',
                                color: isActive ? ivory : muted,
                                cursor: isActive ? 'default' : 'pointer',
                                fontWeight: isActive ? 500 : 400,
                            }}
                        >
                            {t(`lang.switcher.${code}`)}
                        </button>
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default LangSwitcher;
